import { PermissionDeniedDialogComponent } from './permission-denied-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { TeamDetails } from '@tokenbox/domain';

export const PermissionDeniedDialog = (
  team: TeamDetails,
  text: string,
  title?: string,
): Parameters<typeof DialogService.prototype.open> => [
  PermissionDeniedDialogComponent,
  {
    header: title,
    data: { text, team },
    modal: true,
    closable: true,
    closeOnEscape: true,
  },
];
